const baseConfig = {
    urlPrefix: ''
}

const config = {
    ljlocal: {
        ...baseConfig,
        environment: 'test',
        // 接口请求地址
        BASE_URL: 'https://test.dcatools.cn:8181',
        apiweb: 'https://test.dcatools.cn:8181',
        // JXS_URL: 'http://localhost:9101',
        JXS_URL: 'https://test.dcatools.cn/newJxs',
        JXSKC_URL: 'https://test.dcatools.cn/newJxsKC',
        // JXSKC_URL: 'http://localhost:9102',
        // JXSDD_URL: 'http://localhost:9103',
        JXSDD_URL: 'https://test.dcatools.cn/newJxsDD',
        EXCEL_URL: 'https://test.dcatools.cn/export',
        FXS_URL: 'https://test.dcatools.cn/newFxs',
        FXSKC_URL: 'https://test.dcatools.cn/newFxsKC',
        FXSDD_URL: 'https://test.dcatools.cn/newFxsDD',
    },
    local: {
        ...baseConfig,
        environment: 'test',
        // 接口请求地址
        // BASE_URL: 'http://localhost:8080/dongcheng_web3',
        // apiweb: 'http://localhost:8080/dongcheng_web3',
        // JXS_URL: 'https://test.dcatools.cn/newJxs',
        BASE_URL: 'https://test.dcatools.cn:8181',
        apiweb: 'https://test.dcatools.cn:8181',
        JXS_URL: 'http://localhost:9101',
        // JXSKC_URL: 'http://localhost:9102',
        JXSDD_URL: 'http://localhost:9103',
        // EXCEL_URL: 'http://localhost:9017',
        // FXS_URL: 'https://test.dcatools.cn/newFxs',
        // BASE_URL: 'https://gdms.dcatools.cn:8180',
        // apiweb: 'https://gdms.dcatools.cn:8180',
        // JXS_URL: 'https://gdms.dcatools.cn/newJxs',
        // FXS_URL: 'https://gdms.dcatools.cn/newFxs',
        // JXSKC_URL: 'https://gdms.dcatools.cn/newJxsKC',
        // JXSDD_URL: 'https://gdms.dcatools.cn/newJxsDD',
        // EXCEL_URL: 'https://gdms.dcatools.cn/export',
    },
    mock: {
        ...baseConfig,
        environment: 'test',
        // 接口请求地址
        BASE_URL: '',
        apiweb: 'https://gdms.dcatools.cn:8180'
    },
    test: {
        ...baseConfig,
        environment: 'test',
        // 接口请求地址
        BASE_URL: 'https://test.dcatools.cn:8181',
        apiweb: 'https://test.dcatools.cn:8181',
        JXSBB_URL: 'https://test.dcatools.cn/newJxsBB',
        JXS_URL: 'https://test.dcatools.cn/newJxs',
        FXS_URL: 'https://test.dcatools.cn/newFxs',
        JXSKC_URL: 'https://test.dcatools.cn/newJxsKC',
        JXSDD_URL: 'https://test.dcatools.cn/newJxsDD',
        EXCEL_URL: 'https://test.dcatools.cn/export',
    },
    prod: {
        ...baseConfig,
        environment: 'prod',
        // 接口请求地址
        BASE_URL: 'https://gdms.dcatools.cn:8180',
        apiweb: 'https://gdms.dcatools.cn:8180',
        JXS_URL: 'https://gdms.dcatools.cn/newJxs',
        FXS_URL: 'https://gdms.dcatools.cn/newFxs',
        JXSKC_URL: 'https://gdms.dcatools.cn/newJxsKC',
        JXSBB_URL: 'https://gdms.dcatools.cn/newJxsBB',
        JXSDD_URL: 'https://gdms.dcatools.cn/newJxsDD',
        EXCEL_URL: 'https://gdms.dcatools.cn/export',
    }
}

export default config[process.env.REACT_APP_ENV] || config.test as typeof config.local
